<div class="orders-table-container bg-primary-blue-50 pt-5 px-5" [ngClass]="hasLoadMore ? 'pb-3' : 'pb-6'">
  <div *ngIf="pharmOrders.length === 0" class="text-center">
    <img src="./assets/icons/divisional-icons/clipboard-blue.svg" height="80px" alt="Clipboard Icon" />
    <h2 class="mt-5 mb-0">{{ emptyMessageTitle }}</h2>
    <p class="p3 mt-1 mb-6">{{ emptyMessage }}</p>
  </div>
  <p-table
    *ngIf="pharmOrders.length > 0"
    [value]="pharmOrders"
    responsiveLayout="stack"
    dataKey="id"
    class="dashboard-active-orders"
  >
    <ng-template pTemplate="header">
      <tr>
        <th data-cy="orders-list-item-description-header">Item Description - Quantity (Qty)</th>
        <!--    <th data-cy="orders-list-last-filled-header">Refill Date</th> -->
        <th data-cy="orders-list-order-number-header">Order Number</th>
        <th data-cy="orders-list-order-status-header">Order Status</th>
        <th data-cy="orders-list-order-action-header">Action</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="4" class="py-7" data-cy="orders-list-empty-message-container">
          <div class="table-empty-message-container flex flex-column align-items-center justify-content-center">
            <h4 class="table-empty-message-title m-0" data-cy="orders-list-empty-message-title">
              {{ emptyMessageTitle }}
            </h4>
            <p class="table-empty-message p4" data-cy="orders-list-empty-message-content">{{ emptyMessage }}</p>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-pharmOrders let-expanded="expanded">
      <tr class="spacer">
        <td [attr.colspan]="4"></td>
      </tr>
      <tr [ngClass]="{ 'bottom-not-rounded': expanded, 'bottom-rounded': !expanded }" data-cy="orders-list-item">
        <td data-cy="orders-list-item-description">
          <span class="p-column-title" data-cy="orders-list-item-description-header"
            >Item Description - Quantity (Qty)</span
          >
          <div class="flex flex-column">
            <div class="inline lg:flex lg:flex-column xl:inline text-sm" *ngFor="let item of pharmOrders.items">
              {{ item.drugDescription }} - Qty: {{ item.quantity }}
            </div>
          </div>
        </td>
        <!--
        <td data-cy="orders-list-last-filled">
          <span class="p-column-title" data-cy="orders-list-last-filled-header">Refill Date</span>
          {{ pharmOrders.shipBy | formatDate }}
        </td>
        -->
        <td data-cy="orders-list-order-number">
          <span class="p-column-title" data-cy="orders-list-order-number-header">Order Number</span>
          {{ pharmOrders.orderNumber }}
        </td>

        <td data-cy="orders-list-order-status">
          <span class="p-column-title" data-cy="orders-list-status-header">Order Status</span>
          <app-order-status-tag
            *ngIf="!!pharmOrders.orderStatus"
            [orderStatus]="pharmOrders.orderStatus === 'Needs Consent' ? 'Ready to Authorize' : pharmOrders.orderStatus"
          ></app-order-status-tag>
          <!-- {{ pharmOrders.orderStatus }} -->
          <span class="flex flex-column"></span>
          <span class="text-black-400 p4 font-normal mr-1"> Refill Date: </span>
          <span class="p3 font-semibold">{{ pharmOrders.shipBy | formatDate }}</span>
        </td>

        <td data-cy="orders-list-item-action">
          <span class="p-column-title" data-cy="orders-list-order-action-header">Action</span>
          <div *ngIf="pharmOrders.trackingNumber">
            <button
              pButton
              type="button"
              label="Track Order"
              class="p-button-outlined"
              [ngClass]="{ 'p-button-sm': (isBelowXl$ | async) === true }"
              (click)="goToTrackOrder(pharmOrders.trackingNumber)"
              data-cy="orders-list-item-tracking-link"
              appClickEvent
              eventName="orders_list_track_order"
            ></button>
          </div>
          <div *ngIf="pharmOrders.orderStatus === 'Needs Consent'">
            <button
              pButton
              type="button"
              label="Review Order"
              class="p-button-outlined"
              [ngClass]="{ 'p-button-sm': (isBelowXl$ | async) === true }"
              (click)="goToAuthorizeOrder(pharmOrders.enterpriseOrderId)"
              data-cy="orders-list-item-authorize-button"
              appClickEvent
              eventName="orders_list_begin_authorize_order"
            ></button>
          </div>
          <!-- This will be addressed in a separate story
          <div
            *ngIf="pharmOrders.orderStatus === 'Too Early to Fill'"
            style="width: 250px"
            class="text-black-400 p4 font-normal mr-1"
          >
            Your order will be ready to authorize on 12/21/2023. Please come back to authorize order.
          </div>
          -->
        </td>
        <td></td>
      </tr>
    </ng-template>
  </p-table>
</div>
